export enum AppleAuthProvider {
  AppleApp = 'apple_app',
  AppleWeb = 'apple_web',
}

export const APPLE_OAUTH_REDIRECT_URI = '/authenticate/login/third-party';
